import React, { Component } from 'react';

class PrivacyInfoUsagePolicyBanner extends Component {

  render() {

    return (
      <div className="banner contact layui-container">
        <div className="title">
          <p>個人情報のお取扱いに関する同意事項</p >
          <p className="en">Privacy Info Usage Policy</p >
        </div>
      </div>
    )
  }
}

export default PrivacyInfoUsagePolicyBanner
